<template>
  <div style="padding: 0px !important;" :id="`popover-1-${STOCKID}`">
    <div
      
      @mouseover="mouseOver()"
    >
      <Icon
        icon="material-symbols:featured-play-list"
        color="#ea5455"
        width="20"
        height="20"
      />
    </div>
    <b-popover :target="`popover-1-${STOCKID}`" triggers="hover focus">
      <b-form ref="form" @submit.prevent="repeateAgain">
        <b-row>
          <b-col cols="12">
            <b-row>
              <b-col>
                <p style="text-align: center">Barkod</p>
              </b-col>
              <b-col>
                <p style="text-align: center">Paket Adet</p>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12">
            <b-row
              v-for="(item, index) in adetler"
              :id="item.id"
              :key="item.id"
              ref="row"
            >
              <!-- Item Name -->
              <b-col>
                <h6 style="text-align: center">{{ item.BARCODE }}</h6>
              </b-col>
              <b-col>
                <h6 style="text-align: center">
                  {{ item.QUANTITY }} {{ item.UNITNAME }}
                </h6>
              </b-col></b-row
            ></b-col
          >
        </b-row></b-form
      >
    </b-popover>
  </div>
</template>
<script>
import Store from "../../../store/store";
import state from "../../../store/state";
import { Icon } from "@iconify/vue2";
export default {
  data() {
    return {
      adetler: [],
      VALUE: "",
      STOCKID: ""
    };
  },
  created() {
    this.VALUE = this.params.value;
    this.STOCKID = this.params.data.STOCKID;
  },
  components: { Icon },
  methods: {
    mouseOver() {
      var vs = this.$vs;
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        token: Store.state.tokenId,
        STOCKID: vm.STOCKID
      };
      soap.createClient(url, function(err, client) {
        client.INT_Ls_SalPlan_PaketList(args, function(err, result) {
          if (result.INT_Ls_SalPlan_PaketListResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_Ls_SalPlan_PaketListResult);
            let list = JSON.parse(vm.veriler.jsonData);
            vm.adetler = list;
          } catch (error) {}
        });
      });
    }
  }
};
</script>
